import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("apha_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const gate = localStorage.getItem("apha_gate");
  if (gate) config.headers["X-Gate-Pass"] = gate;
  return config;
});

api.interceptors.response.use(undefined, (error) => {
  const gateRequired =
    error?.response?.status === 403 &&
    (error.response?.data?.detail === "ACCESS_GATE_REQUIRED" ||
      error.response?.headers?.["x-gate-required"] === "1");
  if (gateRequired) {
    localStorage.removeItem("apha_gate");
    if (window.location.pathname !== "/gate") window.location.assign("/gate");
  }
  if (error?.response?.status === 403 && error.response?.data?.detail === "PASSWORD_CHANGE_REQUIRED" &&
      window.location.pathname !== "/change-password") {
    window.location.assign("/change-password");
  }
  return Promise.reject(error);
});

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return e?.message || "Something went wrong";
}

export default api;
